import React, { useContext, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import CursorContext from '../../providers/Cursor';
import { decidirCookies, decisionCookies, escucharPreferencias } from '../../../cms/cookies';
import { enVistaPrevia } from '../../../cms/sanity';
import { elemento, useTextos } from '../../../cms/textos';
import RESPALDO from '../../../Data/Paginas/paginaComun.json';

const EASE_EXPO = [0.16, 1, 0.3, 1];
const BOTON = 'h-12 flex-1 whitespace-nowrap rounded-full px-6 text-base font-medium transition-colors duration-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-cream';

/**
 * Aviso de cookies: tarjeta flotante que no bloquea la página. Rechazar pesa lo mismo
 * que aceptar, para que el consentimiento sea una decisión y no un reflejo. No sale en
 * la vista previa del panel, donde taparía lo que se está editando.
 */
export default function AvisoCookies() {
    const textos = useTextos('paginaComun', RESPALDO).cookies;
    const Titulo = elemento(textos, 'titulo', 'p');
    const Texto = elemento(textos, 'texto', 'p');
    const { selectEnter, blackSectionEnter } = useContext(CursorContext);
    const [abierto, setAbierto] = useState(() => !enVistaPrevia && decisionCookies() === null);

    useEffect(() => escucharPreferencias(() => setAbierto(true)), []);

    const decidir = (decision) => {
        setAbierto(false);
        decidirCookies(decision);
    };

    return (
        <AnimatePresence>
            {abierto && (
                <motion.aside
                    role="region"
                    aria-label={textos.titulo}
                    initial={{ opacity: 0, y: 32 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 32 }}
                    transition={{ duration: 0.7, ease: EASE_EXPO }}
                    onMouseEnter={blackSectionEnter}
                    className="fixed bottom-4 left-4 right-4 z-[10000] rounded-[1.5rem] bg-ink p-5 text-cream shadow-[0_24px_60px_-16px_rgba(10,10,10,0.6)] ring-1 ring-inset ring-cream/15 sm:left-auto sm:w-[26rem] md:bottom-6 md:right-6 md:p-6"
                >
                    <Titulo className="text-lg font-medium tracking-[-0.01em]">{textos.titulo}</Titulo>
                    <Texto className="mt-2 text-sm leading-relaxed text-cream/65">
                        {textos.texto}{' '}
                        <NavLink to="/politica-de-privacidad#cookies" className="text-cream underline decoration-cream/40 underline-offset-4 transition-colors duration-300 hover:decoration-cream">
                            {textos.enlace}
                        </NavLink>
                    </Texto>
                    <div className="mt-5 flex gap-2">
                        <button type="button" onMouseEnter={blackSectionEnter} onClick={() => decidir('rechazadas')} className={`${BOTON} text-cream ring-1 ring-inset ring-cream/25 hover:ring-cream/60`}>
                            {textos.rechazar}
                        </button>
                        <button type="button" onMouseEnter={selectEnter} onClick={() => decidir('aceptadas')} className={`${BOTON} bg-cream text-ink hover:bg-white`}>
                            {textos.aceptar}
                        </button>
                    </div>
                </motion.aside>
            )}
        </AnimatePresence>
    );
}
